
import { useState } from "react";
import { useLocalStorage } from "@/hooks/use-local-storage";
import { CalendarSettings } from "@/lib/supabase";
import { useCalendarFetch } from "./calendar/use-calendar-fetch";
import { useCalendarSave } from "./calendar/use-calendar-save";
import { useUnavailableSlots } from "./calendar/use-unavailable-slots";
import { UnavailableTimeSlot } from "./calendar/types";

const DEFAULT_SETTINGS: CalendarSettings = {
  startHour: 8,
  endHour: 20,
  workDays: [1, 2, 3, 4, 5, 6],
  unavailableSlots: {},
};

export type { UnavailableTimeSlot };
export type { UnavailableSlotsMap } from "./calendar/types";

export const useCalendarSettings = (
  user: any | null,
  isClientView: boolean
) => {
  const [localSettings, setLocalSettings] = useLocalStorage<CalendarSettings>(
    "calendar-settings",
    DEFAULT_SETTINGS
  );
  
  const [calendarSettings, setCalendarSettings] = useState<CalendarSettings>(localSettings);

  // Fetch delle impostazioni dal server
  const { isLoading } = useCalendarFetch(user, isClientView, localSettings);
  
  // Salvataggio delle impostazioni sul server
  const { isSaving, saveCalendarSettings: saveSettings } = useCalendarSave();
  
  // Gestione degli slot non disponibili
  const {
    addUnavailableSlot,
    removeUnavailableSlot,
    clearUnavailableSlots,
    isTimeSlotUnavailable
  } = useUnavailableSlots(calendarSettings.unavailableSlots);

  // Funzione wrapper per salvare le impostazioni
  const saveCalendarSettings = async (settings: CalendarSettings) => {
    const success = await saveSettings(settings, user, isClientView);
    
    if (success) {
      setCalendarSettings({
        ...settings,
        id: calendarSettings.id
      });
      
      setLocalSettings({
        ...settings,
        id: calendarSettings.id
      });
    }
    
    return success;
  };

  return {
    calendarSettings,
    setCalendarSettings,
    isLoading,
    isSaving,
    saveCalendarSettings,
    addUnavailableSlot,
    removeUnavailableSlot,
    clearUnavailableSlots,
    isTimeSlotUnavailable
  };
};
